import { Button, Col, DatePicker, Form, Row, Select, message } from 'antd';
import { useHistory } from 'react-router-dom';
import { Constants, Roles } from 'common/constants';
import { SenderListingOrderBox } from './SenderListingOrderBox';
import { PATHS } from '@routing/routes';
import { filterOption, selectOptions20 } from 'common/utils/utility';
import TextArea from 'antd/es/input/TextArea';
import { AccountSelector } from '@features/Account';
import { useDispatch, useSelector } from 'react-redux';
import { SenderDetailsSelector } from '@features/SenderDetails';
import { BoxOrderDeliveryViewModel, BoxOrderViewModel } from 'common/models';
import { SubmitOrderBox, UpdateDeliver, UpdateOrderBox } from '../business/OrderBoxBusiness';
import { useEffect, useState } from 'react';
import { OrderBoxSelector } from '../store/OrderBoxSelector';
import { OperationStatus } from 'store/rootTypes';
import { GetTransactionById, TransactionSelector } from '@features/Transaction';
import { EmployeeSelector } from '@features/Employee';
import { commonSelector } from '@features/Common/store/commonSelector';
import dayjs from 'dayjs';
export const OrderBoxDelivery = () => {
  const history = useHistory();
  const accountState = useSelector(AccountSelector);
  const senderDetailsState = useSelector(SenderDetailsSelector);
  const orderAboxState = useSelector(OrderBoxSelector);
  const transactionState = useSelector(TransactionSelector);
  const employeeState = useSelector(EmployeeSelector);
  const commonState = useSelector(commonSelector);
  const dispatch = useDispatch();
  const [lastStatusCode, setLastStatusCode] = useState<string | null>(null);
  const onFinish = async (values: BoxOrderDeliveryViewModel) => {
    const data = { ...transactionState.TransactionSummary?.BoxOrder }; // Create a shallow copy
    await dispatch(
      UpdateDeliver({
        TransactionsId: data.TransactionsId ?? '',
        Date: values.Date ? values.Date : undefined,
      })
    );
    message.success('Box order updated successfully');
    history.push(PATHS.SummaryOrderBox.path);
  };

  useEffect(() => {
    if (accountState.RoleName === Roles.Customer) {
      history.push(PATHS.Home.path);
    }
  }, []);

  return (
    <div className="App">
      <Row justify="center" align="middle">
        <h1>Order an empty box - Delivery</h1>
      </Row>

      <Form name="senderForm" layout="vertical" onFinish={onFinish}>
        <Row justify="center" align="middle">
          <Col xs={24} sm={20} md={12} lg={8} xl={6}>
            <>
              <Form.Item
                label="Delivery date"
                name="Date"
                initialValue={(() => {
                  const deliveryStatus = transactionState.TransactionSummary?.TransStatusDisplay?.find(
                    (x) => x.Code === 'DE'
                  );
                  return deliveryStatus?.CreatedDate ? dayjs(deliveryStatus.CreatedDate, 'DD/MM/YYYY hh:mm A') : '';
                })()}
              >
                <DatePicker size="large" className="full-width" placeholder="Delivery date" format="YYYY-MM-DD" />
              </Form.Item>
            </>

            <div>
              <Button
                className="prevSenderBtn"
                size="large"
                type="default"
                onClick={() => history.push(PATHS.SummaryOrderBox.path)}
              >
                {Constants.BTN_BACK}
              </Button>
              <Button className="nextSenderBtn" size="large" type="primary" htmlType="submit">
                {Constants.BTN_UPDATE}
              </Button>
            </div>
          </Col>
        </Row>
      </Form>
    </div>
  );
};
